<template>
    <div>
        <div class="d-flex justify-content-between">
            <download-excel :data="bids" :fields="csvFields" type="csv">
                <b-button class="export-btn">Export to CSV</b-button>
            </download-excel>
            <div class="table-search ms-3">
                <div class="form-search d-flex">
                    <input
                        id="users-search-input"
                        type="text"
                        v-model="searchValue"
                        class="form-control-search main-form-control @error('search') is-invalid @enderror"
                        name="search"
                        placeholder="Search by Full Name, Email, Phone"
                    />
                </div>
            </div>
        </div>
        <b-table
            class="table-responsive"
            :items="sortedBids"
            :fields="bidsFields"
            striped
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            responsive="lg"
            :per-page="perPage"
            :current-page="currentPage"
        >
            <template v-slot:cell(id)="{ item }">
                <a :href="`/admin/login-as/${item.user_id}?redirect=${encodeURIComponent(`/event/book-artist/${item.id}/${item.venue_id}`)}`">
                    {{ item.id }}
                </a>
            </template>

            <template v-slot:cell(date)="{ item }">
                {{ formatDate(item.date) }}
            </template>

            <template v-slot:cell(created_date)="{ item }">
                {{ formatDate(item.created_date) }}
            </template>

            <template v-slot:cell(venue)="{ item }">
                <div>{{ item.address_of_event }}</div>
            </template>

            <template v-slot:cell(status)="{ item }">
                {{ item.status }}
            </template>

            <template v-slot:cell(booking_id)="{ item }">
                <template v-if="item.booking_id">
                    <a :href="`/admin/bookings/${item.booking_id}`">
                        {{ item.booking_id }}
                    </a>
                </template>
                <template v-else>
                    <span>No Bookings</span>
                </template>
            </template>

            <template v-slot:cell(number_of_applicants)="{ item }">
                <a :href="`/admin/events/events-history/${item.id}`">
                    {{ item.number_of_applicants }}
                </a>
            </template>
        </b-table>
        <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            align="right"
            aria-controls="my-table"
        ></b-pagination>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        name: 'BidsList',
        data: () => ({
            url: '/admin/ajax/events-list',
            bids: [],
            searchValue: '',
            sortDesc: false,
            perPage: 50,
            currentPage: 1,
            sortBy: 'id',
            bidsFields: [
                { key: 'id', sortable: true },
                { key: 'date', sortable: true },
                { key: 'created_date', sortable: true },
                { key: 'user_id', sortable: true },
                { key: 'booker_name', sortable: true },
                { key: 'address_of_event', sortable: true },
                { key: 'status', sortable: true },
                { key: 'artist_booked', sortable: true },
                { key: 'booking_id', sortable: true },
                { key: 'number_of_applicants', sortable: true },
                { key: 'budget', sortable: true },
            ],
            csvFields: {
                Id: 'id',
                Date: 'date',
                Created_Date: 'created_date',
                User_ID: 'user_id',
                Booker_Name: 'booker_name',
                Address_Of_Event: 'address_of_event',
                Status: 'status',
                Artist_Booked: 'artist_booked',
                Booking_Id: 'booking_id',
                Number_Of_Applicants: 'number_of_applicants',
                Budget: 'budget'
            }
        }),
        computed: {
            rows() {
                return this.bids.length
            },
            sortedBids() {
                return [...this.bids].sort((a, b) => {
                    if (this.sortBy === 'date' || this.sortBy === 'created_date') {
                        const dateA = this.parseDate(a[this.sortBy]);
                        const dateB = this.parseDate(b[this.sortBy]);
                        return this.sortDesc ? dateB - dateA : dateA - dateB;
                    }
                    return 0;
                });
            }
        },
        async created() {
            const response = await axios.post(this.url)

            this.bids = response.data.map(bid => ({
                ...bid,
                date: this.formatDateToISO(bid.date),
                created_date: this.formatDateToISO(bid.created_date)
            }))

            this.bids.forEach((bid) => {
                if (bid.status === 'Canceled') {
                    bid._rowVariant = 'danger'
                }
            })
        },
        methods: {
            formatDateToISO(dateStr) {
                if (!dateStr) return null;
                const parsedDate = new Date(dateStr);
                return isNaN(parsedDate.getTime()) ? null : parsedDate.toISOString();
            },
            parseDate(dateStr) {
                return dateStr ? new Date(dateStr).getTime() : 0;
            },
            formatDate(dateStr) {
                if (!dateStr) return '-';
                const date = new Date(dateStr);
                return date.toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' });
            }
        }
    }
</script>
